import SlackConfiguration from "../slack-configuration";
import { NATIVE_INTEGRATION_SLUGS } from "./integrations-config";
import MergeIntegrationDetailPage from "./merge-integration-detail-page";
import NativeIntegrationDetailPage from "./native-integration-detail-page";

const IntegrationDetailDialog = ({
  organization,
  slug,
  open,
  onClose,
}: {
  organization: any;
  slug: string;
  open: boolean;
  onClose: () => void;
}) => {
  if (!slug) {
    return null;
  }

  if (slug === "slack") {
    return (
      <SlackConfiguration
        organization={organization}
        open={open}
        onClose={onClose}
      />
    );
  }

  if ((NATIVE_INTEGRATION_SLUGS as readonly string[]).includes(slug)) {
    return (
      <NativeIntegrationDetailPage
        organization={organization}
        slug={slug}
        open={open}
        onClose={onClose}
      />
    );
  }

  return (
    <MergeIntegrationDetailPage
      organization={organization}
      slug={slug}
      open={open}
      onClose={onClose}
    />
  );
};

export default IntegrationDetailDialog;
